import { Injectable } from '@angular/core';

import { GroupBy } from './stats.interface';

@Injectable()
export class StatsLabelService {
  public translateGroupBy(groupBy: GroupBy): string {
    switch (groupBy) {
      case GroupBy.AgeCategory:
        return "Tranche d'âge";
      case GroupBy.Experience:
        return 'Expérience';
      case GroupBy.City:
        return 'Ville';
      case GroupBy.Status:
        return 'Statut';
      default:
        return 'Inconnu';
    }
  }
}
